import { StudyTypes } from 'lib/generated_constants/projects';

type PartnerScheduledProject = {
  settings?: {
    preStudyMfeScreenerEnabled?: boolean;
  };
  studyTypeId?: number | null;
};

// A scheduling partner (UserTesting) owns the booking on these projects, so sessions cannot be
// scheduled, rescheduled, or cancelled from our side.
export const isPartnerScheduled = (project?: PartnerScheduledProject | null) =>
  project?.studyTypeId === StudyTypes.ONE_ON_ONE &&
  project?.settings?.preStudyMfeScreenerEnabled === true;

export const PARTNER_SCHEDULED_ACTION_DISABLED_MESSAGE =
  'Scheduling for this study is managed in UserTesting. Reschedule or cancel sessions there.';
